import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex flex-col items-center justify-center px-4 py-24 bg-brand-black bg-grain overflow-hidden" data-id="element-71">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-72" />

      <div className="content-relative max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-73">
        <motion.img src="https://cdn.magicpatterns.com/uploads/fLZ3SDZvZwwoh5ByXfg7aF/Photoroom_20260301_184617.png" alt="AS Impulso Digital Logo" className="w-[120px] h-auto mb-12 drop-shadow-[0_0_15px_rgba(212,175,55,0.3)]" initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-74" />

        <motion.h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight tracking-wide" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} data-id="element-75">
          Damos el <span className="text-gradient-gold" data-id="element-76">Impulso Digital</span>{' '}
          que tu Negocio merece.
        </motion.h1>

        <motion.p className="text-lg md:text-xl text-gray-300 mb-12 max-w-2xl font-light tracking-wide" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} data-id="element-77">
          Conversion Landers de alta velocidad que transforman seguidores en
          clientes reales.
        </motion.p>

        <motion.a href="https://wa.me/447311754270" target="_blank" rel="noopener noreferrer" className="bg-gradient-gold text-brand-black font-bold text-lg px-10 py-4 rounded-full shadow-[0_0_20px_rgba(212,175,55,0.4)] hover:shadow-[0_0_30px_rgba(212,175,55,0.6)] transition-shadow duration-300 inline-block" initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.6,
        ease: 'easeOut'
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} data-id="element-78">
          Solicita tu Demo Gratis
        </motion.a>
      </div>
    </section>;
}